import React from "react";
import PropTypes from "prop-types";
import * as classes from "./OneSidedCard.module.css";
import Image from "../image/Image";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS } from "@contentful/rich-text-types";

const OneSidedCard = ({
  image = "default",
  position,
  title,
  text,
  finnishLanguage,
  accordion = false
}) => {
  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        return <p>{children}</p>;
      },
      [BLOCKS.HEADING_3]: (node, children) => {
        return <h3>{children}</h3>;
      }
    }
  };

  return (
    <div
      className={`${classes.wraper} ${position ? "" : classes.reverse} ${
        accordion ? classes.accordion : ""
      }`}
    >
      <div className={classes.content} lang={finnishLanguage ? "fi" : "en"}>
        {title && <h2>{title}</h2>}
        {text && renderRichText(text, options)}
      </div>
      <Image image={image} sided accordion={accordion} />
    </div>
  );
};

OneSidedCard.propTypes = {
  image: PropTypes.object.isRequired,
  position: PropTypes.bool.isRequired,
  title: PropTypes.string,
  text: PropTypes.object,
  finnishLanguage: PropTypes.bool.isRequired
};

export default OneSidedCard;
